import { Injectable } from '@angular/core';
import { environment, endpoints } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { SecurityQuestion } from './models/security-question';
import { Account } from '../../autentication/models/account';
import CryptoJS from 'crypto-js';
import { Auth } from '../../autentication/Auth';
import { User } from '../../autentication/models/user';

@Injectable()
export class CustomerServiceService {

	accounts: Array<Account> = [];

	constructor(private http: HttpClient) { }

	getAccessionsByCpf(cpf: string): Observable<Account[]> {
		return this.http.get(endpoints.attendant.clientAccounts + cpf).pipe(map((data: any) => {

			if (data.Sucesso) {
				this.accounts = data.Retorno.Adesoes.map((account: any) => {

					const newUser = new User();
					newUser.agency = account.Dados.Agencia;
					newUser.accountName = account.Dados.NomeConta;
					newUser.accountType = account.Dados.TipoConta;
					newUser.accountNumber = account.Dados.NumeroConta;
					newUser.name = account.Dados.NomeTitular;
					newUser.loggedUserName = account.Dados.NomeTitular;
					newUser.cpfCnpj = account.Dados.CpfCnpj;
					newUser.personType = account.Dados.TipoPessoa;
					newUser.cpf = cpf.replace(/\D/g, '');
					newUser.tokenSms = data.Retorno.TipoToken === 'SMS' ? true : false;

					const newAcc = new Account();
					newAcc.rights = account.Poder[0];
					newAcc.systemCode = account.CodSistema;
					newAcc.user = newUser;

					return newAcc;

				});

				this.setAccountsClientList(this.accounts);

			}

			return this.accounts;

		}));
	}

	/**
 * Seta a lista de contas do usuário que está sendo atendido.
 * @param accounts Array<Account>
 */
	public setAccountsClientList(accounts: Array<Account>) {

		this.accounts = accounts;
		this.setOnSession('OmniClientAccounts', JSON.stringify(accounts));
	}

  /**
	 * Retorna a lista de contas do usuário que está sendo atendido.
	 */
	public getAccountsClientList(): Array<Account> {
		if (this.getOfSession('OmniClientAccounts')) {
			const bytes = CryptoJS.AES.decrypt(this.getOfSession('OmniClientAccounts'), 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');
			const accounts = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

			this.accounts = JSON.parse(accounts);

		}

		return this.accounts;
	}


public setClientAccountSelected(account: Account) {
	this.setOnSession('OmniClientAccountSelected', JSON.stringify(account));
}

public getClientAccountSelected(): Account {
	if (this.getOfSession('OmniClientAccountSelected')) {
		const bytes = CryptoJS.AES.decrypt(this.getOfSession('OmniClientAccountSelected'), 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');
		let account = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

		account = JSON.parse(account);
		return account;
	}

}

	setOnSession(key, value) {
		value = CryptoJS.AES.encrypt(JSON.stringify(value), 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');

		window.sessionStorage.setItem(key, value);
	}

	getOfSession(key): any {
		return window.sessionStorage.getItem(key);
	}

	getSecurityQuestions(cpf: string): Observable<SecurityQuestion[]> {
		return this.http.get(endpoints.accounts.users + cpf + endpoints.accounts.positiveId).pipe(map((data: any) => {

			return data.Retorno.map(item => {

				const question = new SecurityQuestion();
				question.code = item.CodQuestao;
				question.description = item.DscQuestao;
				question.type = item.TpResposta;
				question.integers = item.RespInteiros;
				question.decimals = item.RespDecimais;
				question.size = item.RespTamanho;
				question.error = false;

				return question;

			});

		}));
	}

	sendAnswer(cpf: string, question, answer: string) {

		const answerData = {
			CodQuestao: question.code,
			Resposta: answer
		};

		return this.http.post(endpoints.accounts.users + cpf + endpoints.accounts.positiveId, answerData);

	}

	accountCompare(item, index, array) {
		return (item.user.accountNumber === this);
	}

	setAccount(account: any) {
		Auth.getInstance().setUser(account.user);
		this.setClientAccountSelected(account);

		const accountData = {
			CPF: account.user.cpf,
			Agencia: account.user.agency,
			Conta: account.user.accountNumber
		};

		return this.http.post(endpoints.accounts.selection, accountData);

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/customer-service/customer-service.service.ts